/**
 * Provider-selection helpers for the happy-flow modal.
 * @module headerModals/utils/hasProviderSelection
 */

import { SelectedProviderRef } from "../types";

/**
 * Returns whether the happy-flow modal ref holds a non-empty provider selection.
 *
 * @param selectedProvider - Mutable ref from the happy-flow provider checkbox
 * @returns `true` when id or name is non-empty after trimming
 */
export const hasProviderSelection = (
  selectedProvider: SelectedProviderRef,
): boolean => {
  const { id, name } = selectedProvider;
  return id.trim() !== "" || name.trim() !== "";
};
